<div class="card">
  <div class="card-header compact">
    <h1>Notes</h1>
  </div>
  <div *ngIf="notes && notes.length > 0; else emptyState" class="notes">
    <div *ngFor="let note of notes" class="note">
      <div class="avatar">
        <app-avatar [users]="$any(note)" [enablePopover]="false" [enableAnimation]="true"></app-avatar>
      </div>
      <div class="note-right">
        <div data-id="note-body-row" class="note-info">
          <span class="name">{{ note.firstname }} {{ note.lastname }}</span>
          <span class="timestamp">
            <a data-id="delete-note-button" *ngIf="canManageNotes" (click)="deleteNote(note._id)" class="delete-link">Delete</a>
            {{ note.created | date:'short' }}
          </span>
        </div>
        <div class="note-body">{{ note.text }}</div>
      </div>
    </div>
  </div>
  <form *ngIf="canManageNotes" class="note-form">
    <textarea
      data-id="note-text-box"
      name="newNote"
      [(ngModel)]="newNote"
      #noteField="ngModel"
      maxlength="2000"
      placeholder="Add a note"
      class="form-inline form-control notes-textarea">
    </textarea>
    <small *ngIf="noteField.invalid && (noteField.dirty || noteField.touched)" class="help-block">
      <div *ngIf="noteField.errors.maxlength">Comments are limited to 2000 characters.</div>
    </small>
    <div class="spacer-sm"></div>
    <button data-id="add-note-button" type="submit" class="btn btn-primary"
      [disabled]="!newNote" (click)="saveNote()">
      Add Note
    </button>
  </form>
</div>
<ng-template #emptyState>
  <div class="blank-state">
    <mat-icon class="sm raised blue">notes</mat-icon>
    <p>No notes have been added yet</p>
  </div>
</ng-template>
